/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAsync } from 'react-use';
import { Status } from 'components';
import { useMixpanel } from 'context';
import { inIFrame } from 'utils';
import { getReceiveOrderDetails } from './api';
import { isBinBlock } from './Buy/utils';
import { OnrampLayout } from './components';
import { useOnrampData } from './context';

export const Cancelled = () => {
  const { spacing } = useTheme();
  const { formatMessage } = useIntl();
  const { mixpanelTrackEvent } = useMixpanel({
    Product: 'TopUp',
    Page: 'Cancelled',
    onMountProps: {
      description: 'User ended up on the cancelled page.',
    },
  });
  const { receiveOrderPreviewId, failureRedirectUrl } = useOnrampData();

  const { value } = useAsync(() => {
    return getReceiveOrderDetails(receiveOrderPreviewId);
  });

  useEffect(() => {
    if (failureRedirectUrl) {
      mixpanelTrackEvent('Redirecting to failure page');
      setTimeout(() => {
        const windowLocation = inIFrame()
          ? window.parent.location
          : window.location;
        windowLocation.replace(failureRedirectUrl);
      }, 1000);
    }
  }, [failureRedirectUrl, mixpanelTrackEvent]);

  return (
    <OnrampLayout
      topChildren={
        <div>
          <Status
            heading={formatMessage({
              id: 'page.onramp.error.transactionStopped.title',
            })}
            subHeading={[
              failureRedirectUrl
                ? formatMessage({ id: 'page.onramp.failure.redirect' })
                : formatMessage({
                    id: 'page.onramp.error.transactionStopped.info',
                  }),
              ...(value && value.errors?.length
                ? value.errors.map((error) =>
                    isBinBlock(error)
                      ? formatMessage({ id: 'page.onramp.error.binBlock' })
                      : ''
                  )
                : []),
            ]}
            imageProps={{
              name: 'unplugged',
              size: spacing.xxl,
              showPlaceholder: false,
            }}
          />
        </div>
      }
    />
  );
};

export default Cancelled;
